"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-unused-vars */
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const AboutUs_1 = __importDefault(require("../../views/landing/AboutUs"));
const Support_1 = __importDefault(require("../../views/landing/Support"));
const Privacy_1 = __importDefault(require("../../views/landing/Privacy"));
const Terms_1 = __importDefault(require("../../views/landing/Terms"));
exports.default = ({ renderer }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_router_dom_1.Route, { path: "/" /* RoutePath.HOME */, element: renderer(AboutUs_1.default) }),
        react_1.default.createElement(react_router_dom_1.Route, { path: "/support" /* RoutePath.SUPPORT */, element: renderer(Support_1.default) }),
        react_1.default.createElement(react_router_dom_1.Route, { path: "/privacy-policy" /* RoutePath.PRIVACY_POLICY */, element: renderer(Privacy_1.default) }),
        react_1.default.createElement(react_router_dom_1.Route, { path: "/terms-and-conditions" /* RoutePath.TERMS */, element: renderer(Terms_1.default) }),
        react_1.default.createElement(react_router_dom_1.Route, { path: "*" /* RoutePath.UNAUTHORIZED_WILDCARD */, element: react_1.default.createElement(react_router_dom_1.Navigate, { to: "/" /* RoutePath.HOME */ }) })));
};
